import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarIcon } from '@factorialco/f0-react'
import { Upload } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface UploadAreaProps {
  isDragging: boolean
  onDragOver: (e: React.DragEvent) => void
  onDragLeave: (e: React.DragEvent) => void
  onDrop: (e: React.DragEvent) => void
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const UploadArea = ({
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileSelect,
}: UploadAreaProps) => {
  return (
    <div
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onClick={() => document.getElementById('pdf-file-input')?.click()}
      style={{
        cursor: 'pointer',
        flexGrow: 1,
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
      }}
    >
      <Box
        flexGrow
        height="full"
        padding="s1"
        borderRadius={{ all: 'abs012' }}
        border={
          isDragging
            ? {
                all: {
                  width: 's4',
                  style: 'solid',
                  color: 'viridian400',
                },
              }
            : false
        }
      >
        <Box
          flexNoShrink
          flexGrow
          height="full"
          border={{
            all: {
              width: 's2',
              style: 'dashed',
              color: isDragging ? 'grey600' : 'grey400',
            },
          }}
          style={{
            transition: '0.1s',
          }}
          borderRadius={{ all: 'abs008' }}
          paddingX="s16"
          paddingY="s16"
          alignItems="center"
          justifyContent="center"
          background={isDragging ? 'viridian100' : undefined}
        >
          <input
            id="pdf-file-input"
            type="file"
            accept="application/pdf"
            multiple
            style={{ display: 'none' }}
            onChange={onFileSelect}
          />
          <Box gap="s8" alignItems="center">
            <F0AvatarIcon icon={Upload} size="lg" />

            <Text.Normal size="300" color="grey1000">
              {i18n.t('pages.upload_files_modal.upload.upload_area.drag_and_drop')}
            </Text.Normal>
            <Text.Normal size="200" color="grey800">
              {i18n.t('pages.upload_files_modal.upload.upload_area.only_pdf_files')}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
    </div>
  )
}
